import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {GlobalCopilotMenu} from './GlobalCopilotMenu'

registerReactPartial('global-copilot-menu', {
  Component: GlobalCopilotMenu,
})
